import { useAtomValue } from 'jotai'
import axios from 'axios'
import {
    useQuery,
} from '@tanstack/react-query'

import { selectedMunicipalityIdAtom } from '@/state'
import type { NotificationStatuses } from '@/types'

export function useUnreadNotifications() {
    
    const municipalityId = useAtomValue(selectedMunicipalityIdAtom)

    return useQuery({
        queryKey: ['unreadNotifications', municipalityId],
        queryFn: async () => {
            const { data } : { data: NotificationStatuses } = await axios.get(
                `/api/notification_status/status?municipality_id=${municipalityId}`
            )
            return data
        },
        staleTime: 1000*30,
        refetchInterval: 1000*30,
        enabled: !!municipalityId,
    })
}
